import {
  PRIORITY_LABELS,
  dateFr,
  entityBySync,
  eur,
  type Priority,
  type TraitementDto,
} from '@cockpit/shared';
import { Badge, Button } from '@cockpit/ui';
import { CheckCircle2, RotateCcw } from 'lucide-react';
import { dateTime } from '../../lib/format.js';

export const PRIO_TONE = { crit: 'danger', high: 'warn', norm: 'neutral' } as const;

export function PrioBadge({ prio }: { prio: Priority }) {
  return (
    <Badge tone={PRIO_TONE[prio]} dot>
      {PRIORITY_LABELS[prio]}
    </Badge>
  );
}

export const entLabel = (code: string) => entityBySync(code)?.label ?? code;

/** Date courte : jj/mm, avec l’année si elle diffère de l’année en cours. */
export const shortDate = (iso: string | null) => dateFr(iso, new Date().getFullYear());

/** Montant d'enjeu en grand, avec son libellé. */
export function Stake({ value, label, tone }: { value: string; label: string; tone?: 'good' | 'bad' }) {
  return (
    <div className="text-right">
      <p
        className={
          'tnum font-display text-[19px] font-bold leading-tight ' +
          (tone === 'good' ? 'text-success-700' : tone === 'bad' ? 'text-danger-700' : 'text-ink')
        }
      >
        {value}
      </p>
      <p className="text-[11px] uppercase tracking-[0.08em] text-ink-3">{label}</p>
    </div>
  );
}

export function DoneButton({
  done,
  info,
  onToggle,
  size = 'sm',
}: {
  done: boolean;
  info?: TraitementDto;
  onToggle: () => void;
  size?: 'sm' | 'md';
}) {
  return (
    <Button
      size={size}
      variant={done ? 'ghost' : 'secondary'}
      onClick={onToggle}
      title={done && info ? `Traité par ${info.by} le ${dateTime(info.at)}` : undefined}
      icon={done ? <RotateCcw size={16} strokeWidth={1.75} /> : <CheckCircle2 size={16} strokeWidth={1.75} />}
    >
      {done ? 'Rouvrir' : 'Marquer comme traité'}
    </Button>
  );
}

export const money = eur;
